import type { IdentityConsumer, Orders } from 'src/gql/graphql';

export enum NavBarVariant {
  side = 'side',
  top = 'top',
}

export enum AccountTab {
  account = 'account',
  preferences = 'preferences',
  orders = 'orders',
  bankAccount = 'bank-account',
  loyalty = 'loyalty',
  referrals = 'referrals',
  wallet = 'wallet',
}

export type AccountRoutes = {
  account: string;
  preferences: string;
  orders: string;
  bankAccount?: string;
  loyalty?: string;
  referrals?: string;
  wallet?: string;
};

export type ConsumerUser = Pick<IdentityConsumer, 'profile'> & {
  id: string;
  viewOrderId?: string[] | string | null;
  createdAt: string | null;
  exists: boolean;
  loading: boolean;
  token?: string;
};

export type ConsumerOrder = Pick<
  Orders,
  'createdAt' | 'deliveryInfo' | 'dispensary' | 'dispoTimezone' | 'orderId' | 'orders' | 'status' | 'totalCost'
>;
